;(function($){

    function Plans() {

        var modal = new tingle.modal({
            footer: true,
            stickyFooter: false,
            closeLabel: "Close",
            cssClass: ['custom-class-1', 'custom-class-2'],
            onClose: function() {
                modal.setContent('');
            }
        }); 
    
        modal.addFooterBtn('Fechar', 'tingle-btn tingle-btn--pull-right tingle-btn--danger', function() {
            modal.close();
        });

        $(document).on('click', '.btn-plans', function(e){
            e.preventDefault();

            var btnPlans = this;
            
            $(this).text("Carregando...");           

            $.get($("#app_url").val() + "/api/turmas/" + $(this).data('classe') + "/planos", function(data) {

                var rows = '';
                
                var promises = [];

                $.each(data, function(index, value) {

                    rows +='<tr>'+
                        '<td data-label="Plano">'+ value.type_plans.name +'</td>'+
                        '<td data-label="Duração">'+ value.plots +' Mes(es)</td>'+
                        '<td data-label="Forma de Pagamento">'+ value.method_payment +'</td>'+
                        '<td data-label="Valor">'+ value.value +' Mensais</td>' +
                    '</tr>'; 

                    promises.push(value);
                });

                $.when.apply($, promises).then(function() {
                    
                    var table = '<table>' +
                        '<thead>' +
                            '<tr>'+
                                '<th>' +
                                    'Plano'+
                                '</th>'+
                                '<th>'+
                                    'Duração'+
                                '</th>'+
                                '<th>'+
                                    'Forma de Pagamento'+
                                '</th>'+
                                '<th>'+
                                    'Valor'+
                                '</th>'+
                            '</tr>'+
                        '</thead>'+
                        '<tbody>'+ rows +'</tbody>'+
                    '</table>';

                    modal.setContent(table);
                    $(btnPlans).text("Consulte Valores");                    
                    modal.open(); 
                });                                             
            });                  
            
        });
    }

   	new Plans();

}(jQuery));
 
 
 
 
